import { defineMessages } from 'react-intl';

export const storedPaymentMessages = defineMessages({
    savePaymentLabel: {
        id: 'storedPayments.savePayment',
        description: 'Label for toggle button indicating that payment should be stored.',
        defaultMessage: 'Save this credit card for future Gift Card purchases'
    }
});
